import c from './Landing.module.css';
import { ENGAGEMENTS, FUNDAMENTALS } from './data';

export function Fundamentals() {
  return (
    <section id="fundamentals" className={c.fundamentals}>
      <div className={`${c.container} ${c.fundamentalsInner}`}>
        <div className={c.sectionHead}>
          <div>
            <div className={c.eyebrow}>04 — FUNDAMENTALS</div>
            <h2 className={c.h2sm}>The engineering underneath</h2>
          </div>
          <p className={c.sectionBlurb}>
            Cloud, web and mobile delivery — the same team that builds the AI builds the product around it.
          </p>
        </div>
        <div className={c.fundGrid}>
          {FUNDAMENTALS.map((f) => (
            <div key={f.title} className={c.fundCard}>
              <div className={c.fundTitle}>{f.title}</div>
              <div className={c.fundLine}>{f.stack}</div>
              <div className={`${c.fundLine} ${c.fundLineMuted}`}>{f.data}</div>
            </div>
          ))}
        </div>
        <div className={c.engageRow}>
          <span className={c.engageLabel}>ENGAGEMENTS</span>
          <div className={c.capItems}>
            {ENGAGEMENTS.map((e) => <span key={e} className={c.chip}>{e}</span>)}
          </div>
        </div>
      </div>
    </section>
  );
}
